import { useMsalAuth } from '@contexts/msal-provider';
import { APP_ROUTES } from '@routes/routes.constants';
import * as React from 'react';

import type { UseRegisterUserContentReturn } from './useRegisterUserContent.types';

export function useRegisterUserContent(): UseRegisterUserContentReturn {
  const { login } = useMsalAuth();
  const [emailExists, setEmailExists] = React.useState(false);
  const [isLoggingIn, setIsLoggingIn] = React.useState(false);
  const [loginError, setLoginError] = React.useState(false);

  const handleNavigateToLanding = React.useCallback((): void => {
    globalThis.location.assign(APP_ROUTES.DEFAULT);
  }, []);

  const handleSubmitSuccess = React.useCallback((): void => {
    setLoginError(false);
    setIsLoggingIn(true);
    void login('b2c').catch((error: unknown) => {
      console.error('Registration login failed:', error);
      setLoginError(true);
      setIsLoggingIn(false);
    });
  }, [login]);

  const handleEmailExists = React.useCallback((): void => {
    setEmailExists(true);
  }, []);

  const handleBackToForm = React.useCallback((): void => {
    setEmailExists(false);
  }, []);

  return {
    emailExists,
    isLoggingIn,
    loginError,
    handleNavigateToLanding,
    handleSubmitSuccess,
    handleEmailExists,
    handleBackToForm,
  };
}
